import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`institutions/${id}`)
}
